import { render, staticRenderFns } from "./tiles.vue?vue&type=template&id=19a77dd4"
import script from "./tiles.vue?vue&type=script&lang=ts"
export * from "./tiles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports